import { PermissionNames } from "../types/account.types"
import { RightElement, SettingsParentPage } from "./header.types"

export const NAVIGATION_ITEMS = [
  {
    url: 'https://willowhavenfarmpa.com/about-us',
    route: '',
    name: 'About us',
    mobile: false,
    submenu: [
      {
        route: '/pages/producers',
        name: 'Our Local Farmers & Producers'
      },
      // {
      //   url: '/pages/procurement-standards',
      //   name: 'Saint Luke\'s CSA',
      // },
      {
        url: 'https://willowhavenfarmpa.com/workplace-wellness',
        name: 'Workplace Wellness'
      },
      {
        route: '/pages/delivery-areas',
        name: 'Our Delivery Area'
      },
    ]
  },
  {
    url: 'https://willowhavenfarmpa.com/home-2',
    name: 'How it works'
  },
  {
    url: 'https://willowhavenfarmpa.com/events',
    name: 'Events'
  },
  {
    route: '/pages/gift-cards',
    name: 'Gift Cards'
  },
  {
    url: '',
    route: '',
    name: 'Contact Us',
    submenu: [
      {
        url: 'mailto:farmer@willowhavenfarmpa.com',
        route: '',
        name: 'Email Us'
      },
      {
        url: 'https://t.me/whfmembersupport',
        route: '',
        name: 'Telegram Support'
      }
    ]
  },
]


export const NAVIGATION_ITEMS_RIGHT = [
  {
    url: 'https://willowhavenfarmpa.com/blog',
    name: 'Blog'
  },
  {
    route: '/shop',
    name: 'Shop',
    mobile: false
  }
]

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'account_circle',
    name: 'Account settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals
      },
    ],
    permissionName: PermissionNames.settings
  },
  {
    icon: 'credit_card',
    name: 'Billing settings',
    children: [
      {
        route: '/settings/billing/payment-method',
        name: 'Payment Method',
        permissionName: PermissionNames.settingsPaymentMethod
      },
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory
      },
    ],
    permissionName: PermissionNames.settings
  },
]

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop
  },
  {
    id: 'toggleCardPreviewNav',
    tooltip: 'Cart',
    route: '',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true,
    shouldShowCartPreview: true
  },
]
